import { InstanceScreen } from 'component/navigation/instance';

export default function SpaceModTaskTreeViewScreen() {
    return <InstanceScreen screenKey='modTaskTreeView' />;
}
